module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cover-book",
    class: {
      'animated-background': !_vm.cover
    }
  }, [(_vm.cover) ? _c('img', {
    staticClass: "img",
    attrs: {
      "src": _vm.cover
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-114d23f5"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/presentation/cover-book.vue
// module id = 1356
// module chunks = 1